import salesSerialApi from '@/api/salesSerial';

const defaultState = () => ({
	salesSerialResults: [],
	salesSerialPagination: '',
	responSukses: '',
	konfirmResponse: {},
	alert: '',
});

const state = defaultState();

const getters = {

};

const mutations = {
	listSalesSerial(state, data) {
		state.salesSerialResults = data.data
		state.salesSerialPagination = data.pagination;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.konfirmResponse = {};
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataProduct(state){
		Object.assign(state, defaultState())
	}
};

const actions = {
	getSalesSerial({ commit }, params) {
		salesSerialApi.getSalesSerial(params).then(({ data: { data } }) => {
			commit('listSalesSerial', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listSalesSerial', { data: [], pagination: {} } );
		});
	},
	async exportSalesSerial({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await salesSerialApi.exportSalesSerial(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: "Gagal export data serial produk"
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	errorHandler({ commit }, response) {
		commit("konfirmasiSukses", '');
		switch (response.message) {
			case 'error_validation':
			commit('saveConfirmResponse', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true })
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};